import { formatDate } from '@angular/common';

const formatDateWithoutTime = (date: any) => {
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};
function setTime(date: Date, time: string) {
  const [hours, minutes] = time?.split(':');
  date.setHours(parseInt(hours), parseInt(minutes));
}
export function getJobId(scheduleData: any, date: any) {
  return scheduleData?.job_details?.schedule_details?.job_id
    ? scheduleData?.job_details?.schedule_details?.job_id
    : date
      ? scheduleData?.job_details?.schedule_details?.[
          formatDate(new Date(date), 'yyyy-MM-dd', 'en_US')
        ]?.job_id
      : scheduleData?.job_details?.job_id;
}
export function getPatrolId(scheduleData: any, date: any) {
  return scheduleData?.patrol_route_details?.schedule_details?.patrol_route_id
    ? scheduleData?.patrol_route_details?.schedule_details?.patrol_route_id
    : date
      ? scheduleData?.patrol_route_details?.schedule_details?.[
          formatDate(new Date(date), 'yyyy-MM-dd', 'en_US')
        ]?.patrol_route_id
      : scheduleData?.patrol_route_details?.patrol_route_id;
}
export function getJobStatus(job: any, date: any, missedPatrolScanData?: any) {
  const scheduleData = job?.shift_info;
  const shiftDate = formatDateWithoutTime(new Date(date));

  const todayDate = formatDateWithoutTime(new Date());
  // future shifts
  if (shiftDate > todayDate) return;

  const isShiftToday = shiftDate === todayDate;

  let startDateTime: any = new Date(date);
  let endDateTime: any = new Date(date);

  if (scheduleData?.repeat_type == 'once') {
    startDateTime = new Date(
      scheduleData?.start_day + ' ' + scheduleData?.start_time,
    );
    endDateTime = new Date(
      scheduleData?.end_day + ' ' + scheduleData?.end_time,
    );
  } else {
    setTime(startDateTime, scheduleData?.start_time);
    setTime(endDateTime, scheduleData?.end_time);
    if (startDateTime.getTime() > endDateTime.getTime()) {
      // overnight schedule ; change enddate
      endDateTime.setDate(endDateTime.getDate() + 1);
    }
  }

  endDateTime = endDateTime.getTime();
  startDateTime = startDateTime.getTime();

  const currentDateTime = new Date().getTime();

  if (isShiftToday) {
    if (currentDateTime > startDateTime) {
      const isSignedIn = job?.assignee_list?.some(
        (assignee: any) => assignee?.signed_in,
      );
      if (
        endDateTime < currentDateTime &&
        job?.id &&
        job?.job_type_dict?.type_identity === 4
      ) {
        const patrolRouteStatus = missedPatrolScanData?.find(
          (patrol: any) => patrol?.patrol_route_id == job?.id,
        );

        if (patrolRouteStatus?.patrol_route_id) {
          return 'Complete with Missed Scans';
        } else {
          return 'Complete';
        }
      }
      return isSignedIn
        ? 'In Progress'
        : job?.assignee_list?.length
          ? 'Late to Shift'
          : 'Unassigned Shift';
    } else {
      return 'Not Started';
    }
  } else if (
    endDateTime < currentDateTime &&
    job?.id &&
    job?.job_type_dict?.type_identity === 4
  ) {
    const patrolRouteStatus = missedPatrolScanData?.find(
      (patrol: any) => patrol?.patrol_route_id == job?.id,
    );

    if (patrolRouteStatus?.patrol_route_id) {
      return 'Complete with Missed Scans';
    } else {
      return 'Complete';
    }
  } else if (endDateTime + 3600000 * 24 < currentDateTime && job?.id) {
    return 'Stale';
  }

  return '';
}
export function getJobServiceType(scheduleData: any, date: any) {
  return formatDateWithoutTime(new Date(date)) >=
    formatDateWithoutTime(new Date())
    ? scheduleData?.job_details?.schedule_details?.service_type
      ? scheduleData?.job_details?.schedule_details?.service_type
      : date
        ? scheduleData?.job_details?.schedule_details?.[
            formatDate(new Date(date), 'yyyy-MM-dd', 'en_US')
          ]?.service_type
        : ''
    : '';
}
export function getEventAssignees(
  scheduleData: any,
  date: any,
  isAdminDispatcher: any,
) {
  return isAdminDispatcher ? getEventAssigneeList(scheduleData, date) : [];
}

export function getEventAssigneeList(scheduleData: any, date: any) {
  return scheduleData?.patrol_route_details
    ? scheduleData?.patrol_route_details?.schedule_details?.assignee_data
      ? scheduleData?.patrol_route_details?.schedule_details?.assignee_data
      : date
        ? scheduleData?.patrol_route_details?.schedule_details?.[
            formatDate(new Date(date), 'yyyy-MM-dd', 'en_US')
          ]?.assignee_data
        : []
    : scheduleData?.job_details?.schedule_details?.assignee_data
      ? scheduleData?.job_details?.schedule_details?.assignee_data
      : date
        ? scheduleData?.job_details?.schedule_details?.[
            formatDate(new Date(date), 'yyyy-MM-dd', 'en_US')
          ]?.assignee_data
        : [];
}
export function trashIconIf(
  scheduleData: any,
  date: any,
  isAdminDispatcher: any,
) {
  if (!isAdminDispatcher) {
    return false;
  }
  let startTime = new Date(date);
  if (scheduleData?.repeat_type == 'once') {
    startTime = new Date(
      scheduleData?.start_day + ' ' + scheduleData?.start_time,
    );
  } else {
    setTime(startTime, scheduleData?.start_time);
  }
  return Boolean(startTime.getTime() > new Date().getTime());
}
export function isCurrentOrFutureJob(
  scheduleData: any,
  date: any,
  isAdminDispatcher: any,
) {
  if (!isAdminDispatcher) {
    return false;
  }
  let endDateTime = new Date(date);
  if (scheduleData?.repeat_type == 'once') {
    endDateTime = new Date(
      scheduleData?.end_day + ' ' + scheduleData?.end_time,
    );
  } else {
    setTime(endDateTime, scheduleData?.end_time);
    if (scheduleData?.start_time > scheduleData?.end_time) {
      endDateTime.setDate(endDateTime.getDate() + 1);
    }
  }
  return Boolean(endDateTime.getTime() > new Date().getTime());
}

export function getScheduleStatus(
  shiftInfo: any,
  date: any,
  missedPatrolScanData?: any,
  shiftType: 'patrol' | 'runsheet' | 'job' = 'job',
) {
  const shiftDate = formatDateWithoutTime(new Date(date));

  const todayDate = formatDateWithoutTime(new Date());
  // future shifts
  if (shiftDate > todayDate) return;

  const isShiftToday = shiftDate === todayDate;

  let startDateTime: any = new Date(date);
  let endDateTime: any = new Date(date);

  if (shiftInfo?.repeat_type == 'once') {
    startDateTime = new Date(shiftInfo?.start_datetime);
    endDateTime = new Date(shiftInfo?.start_endtime);
  } else {
    setTime(startDateTime, shiftInfo?.start_time);
    setTime(endDateTime, shiftInfo?.end_time);
    if (startDateTime.getTime() > endDateTime.getTime()) {
      // overnight schedule ; change enddate
      endDateTime.setDate(endDateTime.getDate() + 1);
    }
  }

  endDateTime = endDateTime.getTime();
  startDateTime = startDateTime.getTime();

  const currentDateTime = new Date().getTime();

  if (isShiftToday) {
    if (currentDateTime > startDateTime) {
      const isClockedIn = shiftInfo?.is_clocked_in;
      if (
        endDateTime < currentDateTime &&
        shiftInfo?.id &&
        shiftType == 'patrol'
      ) {
        const patrolRouteStatus = missedPatrolScanData?.find(
          (patrol: any) => patrol?.patrol_route_id == shiftInfo?.id,
        );

        if (patrolRouteStatus?.patrol_route_id) {
          return 'Complete with Missed Scans';
        } else {
          return 'Complete';
        }
      }
      return isClockedIn
        ? 'In Progress'
        : shiftInfo?.assignee_id
          ? 'Late to Shift'
          : 'Unassigned Shift';
    } else {
      return 'Not Started';
    }
  } else if (
    endDateTime < currentDateTime &&
    shiftInfo?.id &&
    shiftType == 'patrol'
  ) {
    const patrolRouteStatus = missedPatrolScanData?.find(
      (patrol: any) => patrol?.patrol_route_id == shiftInfo?.id,
    );

    if (patrolRouteStatus?.patrol_route_id) {
      return 'Complete with Missed Scans';
    } else {
      return 'Complete';
    }
  } else if (endDateTime + 3600000 * 24 < currentDateTime && shiftInfo?.id) {
    return 'Stale';
  }

  return '';
}
